import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { JoinService } from '../../../services/join/join.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import environment from '../../../../environments/environment';
import { GrowlerService } from '../../../services/growler.service';

export interface SignupOrganization {
    id: number;
    name: string;
    logoSrc: string;
}

@Injectable({ providedIn: 'root' })
export class SignUpOrganizationResolver implements Resolve<SignupOrganization> {
    private readonly payHoaLogo = '/assets/images/payhoa/hoa-management-software/payhoa-logo.svg';

    constructor(
        private _joinService: JoinService,
        private _router: Router,
        private _growler: GrowlerService,
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SignupOrganization> {
        const orgUrl = route.paramMap.get('org_url');
        const orgId = orgUrl ? parseInt(orgUrl.split('-').shift(), 10) : null;
        if (orgId !== null) {
            return this._joinService.getOrgById(orgId).pipe(
                map((res) => {
                    const logoSrc = res.hasLogo ? `${environment.S3URL}${environment.OrgLogoBucket}/${res.id}/logo.png` : this.payHoaLogo;
                    return {
                        id: res.id,
                        name: res.name,
                        logoSrc,
                    };
                }),
                catchError((err) => {
                    this._growler.error('Error', 'Unable to Load Organization.');

                    // noinspection JSIgnoredPromiseFromCall
                    this._router.navigate(['/sign-up']);

                    throw new Error(err);
                }),
            );
        }

        return of({ logoSrc: this.payHoaLogo } as SignupOrganization);
    }
}
